// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"370":"bd553698","504":"7196af61","524":"7c77e9fa","579":"b5cddd12","584":"dd72dc48"}[chunkId] + ".chunk.js");